import { Grid, Typography } from "@mui/material";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import Assessment from "./Assessment";
import ClientEndorsement from "./ClientEndorsement";
import ClientInterview from "./ClientInterview";
import ScreeningStage from "./ScreeningStage";
import ShortlistStage from "./ShortlistStage";

type Props = {
  candidate?: CandidateDetails;
  jobId: string;
};

const StatusManager = ({ candidate, jobId }: Props) => {
  if (!candidate) return null;
  if (candidate.disqualified) {
    return (
      <Grid item>
        <Typography fontSize={"14px"} color={"#0F1829"}>
          Candidate has been disqualified with the following reason:
        </Typography>
        <Typography fontSize={"14px"} fontWeight={700} color="error">
          {candidate.disqualificationReason || "No reason provided"}
        </Typography>
      </Grid>
    );
  }
  if (candidate?.stage === "screeningByTalentTeam") {
    return <ScreeningStage candidate={candidate} />;
  }
  if (candidate?.stage === "shortlist") {
    return <ShortlistStage candidate={candidate} job={{ jobId }} />;
  }
  if (candidate?.stage?.includes("clientEndorsement")) {
    return <ClientEndorsement />;
  }
  if (candidate?.stage?.includes("clientInterview")) {
    return <ClientInterview candidate={candidate} jobId={jobId} />;
  }
  if (candidate?.stage?.includes("culturalInterview")) {
    return <ClientInterview candidate={candidate} jobId={jobId} />;
  }
  if (candidate?.stage?.includes("technicalAssessment")) {
    return <Assessment candidate={candidate} jobId={jobId} />;
  }
  return null;
};

export default StatusManager;
